import React, { FC } from "react";
import { Document, Page, View, Image, Text, StyleSheet, Font } from '@react-pdf/renderer';
// @ts-ignore
import notoRegular from '../../fonts/NotoSans_regular.ttf';
// @ts-ignore
import noto700 from '../../fonts/NotoSans_bold.ttf';

type Props = {
    spotName: string;
    qrDataUri: string;
};

export const QRDocument: FC<Props> = ({ spotName, qrDataUri }) => {
    Font.register({
        family: 'Noto Sans JP',
        src: notoRegular,
        fontStyle: 'normal',
        fontWeight: 'normal,'
    });
    Font.register({
        family: 'Noto Sans JP',
        src: noto700,
        fontStyle: 'normal',
        fontWeight: 'bold'
    });

    const styles = StyleSheet.create({
        pdf_wrap: {
            display: 'flex',
            flexDirection: 'row',
            padding: '24px 24px 0px 40px',
            width: '595px',
            height: '822px',
            backgroundColor: '#ffffff',
            fontFamily: 'Noto Sans JP',
        },
        left__title: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '12px 12px 12px 14px',
            width: '262px',
            fontSize: '16px',
            backgroundColor: '#ff6d00',
            color: '#ffffff',
        },
        left__title__img: {
            marginLeft: '-25px',
            width: '26px',
        },
        left__caption: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '10px',
            marginBottom: '36px',
            fontSize: '8px',
        },
        left__caption__row: {
            marginBottom: '6px',
        },
        usage: {
            position: 'relative',
            paddingTop: '20px',
            paddingRight: '14px',
            paddingBottom: '20px',
            paddingLeft: '14px',
            width: '262px',
            backgroundColor: 'rgba(255, 109, 0, 0.1)',
            borderRadius: '20px',
        },
        usage__head: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        usage__head__title: {
            marginTop: '0px',
            marginBottom: '10px',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#ff6d00',
        },
        usage__head__caption: {
            paddingTop: '6px',
            paddingRight: '12px',
            paddingBottom: '6px',
            paddingLeft: '12px',
            borderRadius: '100vh',
            backgroundColor: 'rgba(255, 109, 0, 0.2)',
            fontSize: '6px',
        },
        usage__desc: {
            paddingTop: '14px',
            paddingBottom: '20px',
            borderRadius: '20px',
            fontSize: '8px',
        },
        usage__desc__row: {
            marginBottom: '18px',
        },
        usage__icon: {
            position: 'absolute',
            left: '-2px',
            top: '-20px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '60px',
            height: '60px',
            border: '1px solid #ff6d00',
            borderRadius: '50%',
            backgroundColor: '#ffffff',
        },
        usage__icon__img: {
            width: '30px',
            height: '30px',
        },
        right: {
            marginLeft: '32px',
            border: '1px solid #ff6d00',
        },
        right__part: {
            width: '240px',
            height: '312px',
            borderTop: '1px dashed #ff6d00',
        },
        right__part____short: {
            width: '240px',
            height: '85px',
            borderTop: '1px dashed #ff6d00',
        },
        qrcard: {
            marginTop: '0px',
            marginRight: 'auto',
            marginLeft: 'auto',
            marginBottom: '0px',
            textAlign: 'center',
        },
        qrcard__wrap: {
            position: 'relative',
        },
        qrcard__content: {
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px',
            width: '240px',
            height: '312px',
        },
        qrcard__content__icon: {
            marginBottom: '10px',
            width: '40px',
        },
        qrcard__content__name: {
            paddingTop: '12px',
            paddingRight: '0px',
            paddingBottom: '24px',
            paddingLeft: '0px',
            textALign: 'center',
            fontSize: '16px',
            fontWeight: 'bold',
        },
        qrcard_content_qr_wrapper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            width: '100px',
            height: '100px',
        },
        qr_frame_top_left: {
            top: 0,
            left: 0,
            borderTop: '2px solid #ff6d00',
            borderLeft: '2px solid #ff6d00',
            position: 'absolute',
            width: '20px',
            height: '20px',
        },
        qr_frame_top_right: {
            top: 0,
            right: 0,
            borderTop: '2px solid #ff6d00',
            borderRight: '2px solid #ff6d00',
            position: 'absolute',
            width: '20px',
            height: '20px',
        },
        qr_frame_bottom_left: {
            bottom: 0,
            left: 0,
            borderBottom: '2px solid #ff6d00',
            borderLeft: '2px solid #ff6d00',
            position: 'absolute',
            width: '20px',
            height: '20px',
        },
        qr_frame_bottom_right: {
            bottom: 0,
            right: 0,
            borderBottom: '2px solid #ff6d00',
            borderRight: '2px solid #ff6d00',
            position: 'absolute',
            width: '20px',
            height: '20px',
        },
        qrcard__content__qr: {
            width: '80px',
            height: '80px',
        },
        qrcard__content__caption: {
            marginTop: '10px',
            marginBottom: '20px',
            fontSize: '10px',
            color: '#a8a8a8',
        },
        line____normal: {
            color: '#ff6d00',
            fontWeight: 'bold',
            letterSpacing: -1,
        },
        line____dashed: {
            color: '#ff6d00',
            fontWeight: 'bold',
        }
    });

    return (
        <Document>
            <Page>
                <View style={styles.pdf_wrap}>
                    <View>
                        <View style={styles.left__title}>
                            <Image style={styles.left__title__img} src="/img/map_admin/qr-hat.png" />
                            <Text>スタンプ用QRコード　使用例</Text>
                        </View>
                        <View style={styles.left__caption}>
                            <Text style={styles.left__caption__row}>使用例は2種類ございます。</Text>
                            <Text style={styles.left__caption__row}>お好み、環境に合わせてお選びください。</Text>
                        </View>
                        <View style={styles.usage}>
                            <View style={styles.usage__head}>
                                <View style={styles.usage__head__title}>
                                    <Text>テント型でのご使用</Text>
                                </View>
                                <View style={styles.usage__head__caption}>
                                    <Text>厚めの紙への印刷がおすすめです！</Text>
                                </View>
                            </View>
                            <View style={styles.usage__desc}>
                                <Text style={styles.usage__desc__row}>
                                    ①こちらのデータを印刷いただき、切り取り線（<Text style={styles.line____normal}>----</Text>）に合わせハサミ、カッターなどでこちらの台紙から本体を切り離してください。
                                </Text>
                                <Text style={styles.usage__desc__row}>
                                    ②切り離した本体を、中央の点線（<Text style={styles.line____dashed}>---</Text>）から山折りしてください。
                                </Text>
                                <Text style={styles.usage__desc__row}>
                                    ③端の点線（<Text style={styles.line____dashed}>---</Text>）2つも山折りし、片面にのりをつけてください。のり付けしていない面を重ねて貼り付けていただき、完成です。
                                </Text>
                            </View>
                            <View style={styles.usage__icon}>
                                <Image style={styles.usage__icon__img} src="/img/map_admin/tent.png" />
                            </View>
                        </View>
                        <View style={[styles.usage, { marginTop: '36px' }]}>
                            <View style={styles.usage__head}>
                                <View style={styles.usage__head__title}>
                                    <Text>壁に貼ってのご使用</Text>
                                </View>
                                <View style={styles.usage__head__caption}>
                                    <Text>厚めの紙への印刷、または普通紙に印刷・カット後厚めの紙の上に貼っていただくのががおすすめです！</Text>
                                </View>
                            </View>
                            <View style={styles.usage__desc}>
                                <Text style={styles.usage__desc__row}>
                                    ①こちらのデータを印刷いただき、切り取り線（<Text style={styles.line____normal}>----</Text>）に合わせハサミ、カッターなどで台紙から本体を切り離してください。
                                </Text>
                                <Text style={styles.usage__desc__row}>
                                    ②切り離した本体を、中央の点線（<Text style={styles.line____dashed}>---</Text>）でカットしてください。
                                </Text>
                                <Text style={styles.usage__desc__row}>
                                    ③2つになった本体の、QRコードが印刷がされている方の端の点線（<Text style={styles.line____dashed}>---</Text>）をカットしていただき、完成です。
                                </Text>
                            </View>
                            <View style={styles.usage__icon}>
                                <Image style={styles.usage__icon__img} src="/img/map_admin/wall.png" />
                            </View>
                        </View>
                    </View>
                    <View style={styles.right}>
                        <View style={[styles.right__part____short, { borderTop: 'none' }]}></View>
                        <View style={styles.right__part}></View>
                        <View style={styles.right__part}>
                            <View style={styles.qrcard__wrap}>
                                <View style={styles.qrcard__content}>
                                    <Image style={styles.qrcard__content__icon} src="/img/map_admin/qr-hat.png" />
                                    <Text style={styles.qrcard__content__name}>{spotName}</Text>
                                    <View style={styles.qrcard_content_qr_wrapper}>
                                        <View style={styles.qr_frame_top_left}></View>
                                        <View style={styles.qr_frame_top_right}></View>
                                        <View style={styles.qr_frame_bottom_left}></View>
                                        <View style={styles.qr_frame_bottom_right}></View>
                                        <Image style={styles.qrcard__content__qr} src={qrDataUri} />
                                    </View>
                                    <Text style={styles.qrcard__content__caption}>こちらのバーコードを読み込んでください</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.right__part____short}></View>
                    </View>
                </View>
            </Page>
        </Document>
    );
};
